import { APIPromise } from "services/HttpService";
import { ApiDefinition } from "./ApiDefinition";
import { MeasurementDeviceGeoDTO } from "./model/measurement-devices/MeasurementDeviceGeoDTO";
import { MeasuredValue } from "./model/measurement-devices/MeasuredValue";
import { MeasurementDeviceDTO } from "./model/measurement-devices/MeasurementDeviceDTO";

class MeasurementDevicesApiDefinition extends ApiDefinition {
  constructor() {
    super("/measurementDevices");
  }

  async getGeoMeasurementsDevices(): APIPromise<MeasurementDeviceGeoDTO[]> {
    return this.get(`geoMeasurementDevices`);
  }

  async getMeasurementDevicesReadings(topic: string, devicesId: string): APIPromise<MeasuredValue[]> {
    return this.get(`measurementDevicesReadingsByTopic?topic=${topic}&deviceIds=${devicesId}`);
  }

  async getMeasurementDevicesByTags(): APIPromise<MeasurementDeviceDTO[]> {
    return this.get(`devicesByTags?includeDatasets=true`);
  }
}

export const MeasurementDevicesApi = new MeasurementDevicesApiDefinition();
